import { render, staticRenderFns } from "./FormChange.vue?vue&type=template&id=2ca2dcd0&"
import script from "./FormChange.vue?vue&type=script&lang=js&"
export * from "./FormChange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports